import template from "./live-view-preview.html";
import {liveViewPreviewController} from "./live-view-preview.controller.js";
import "./live-view-preview.scss";

export const liveViewPreviewComponent = {
    template,
    controller: liveViewPreviewController,
    controllerAs: "preview",
    bindings: {
        enabled: "<",
        prWidth: "@",
        prHeight: "@",
        background: "@",
        videoBackground: "@",
        index: "@",
        bgColor: "<",
        bgMode: "<",
        screen: "@",
        mode: "@",
        hideTitle: "<",
        isSingle: "<",
        isPortraite: "<",
        hideOutputPictureVideo: "<",
        hideSharingOptions: "<"
    }
};



// WEBPACK FOOTER //
// ./sources/components/common/live-view-preview/live-view-preview.component.js